import { ErrorMessage, Field, FieldProps, Form, Formik } from 'formik';

import Button from '@/components/shared/Button/Button';
import { Text } from '@/components/shared/Text/Text';
import { TextField } from '@/components/shared/TextField/TextField';

import { useSignInForm } from './hooks/useSignInForm';

const SignIn = () => {
  const { initialValues, validationSchema, handleSubmit, isSubmitting } = useSignInForm();

  return (
    <div className="flex items-center justify-center h-screen animation-fade-in">
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {({ isSubmitting: formikSubmitting }) => (
          <Form className="bg-white-100 p-6 rounded-[16px] w-[438px] flex justify-center flex-col align-center">
            <img src={'/icons/admin_panel.svg'} alt={'hub'} className="w-[171px] m-auto" />
            <Text.H5 className="text-center mt-4 font-bold">Welcome back</Text.H5>
            <Text.Normal className="text-center font-normal">
              Log in with email to <span className="font-semibold">{'HUB'}</span>
            </Text.Normal>

            <div className="my-4">
              <Field name="email">
                {({ field }: FieldProps) => (
                  <TextField {...field} type="email" placeholder="Email" />
                )}
              </Field>
              <ErrorMessage
                name="email"
                component="div"
                className="text-danger-50 font-medium mt-2 text-sm animation-fade-in"
              />
            </div>
            <div className="mb-4">
              <Field name="password">
                {({ field }: FieldProps) => (
                  <TextField {...field} type="password" placeholder="Password" />
                )}
              </Field>
              <ErrorMessage
                name="password"
                component="div"
                className="text-danger-50 font-medium mt-2 text-sm animation-fade-in"
              />
            </div>
            <Button
              type="submit"
              className="m-auto mt-4"
              disabled={formikSubmitting || isSubmitting}
              label={isSubmitting ? 'Logging in...' : 'Log In'}
            />
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default SignIn;
